import React, {useEffect, useRef} from 'react'

import {useAtom, useCtx} from '@reatom/npm-react'
import './style.css'
import SvgSprite from 'championship/src/components/Utils/SvgSprite'
import Field from 'championship/src/components/Fields/Field'
import {atom} from '@reatom/core'
import {
  deleteParticipant,
  getModelAtom,
  groupAtom,
  participantsAtom,
  seedAtom,
  setParticipantsAction
} from '../../model'
import SearchItem from './SearchItem'
// import { toNumberOrNull } from '../../../../functions'
import { toNumberOrNull } from 'championship/src/functions'

// function toNumberOrNull(value) {
//   if (value === null) return null;
//   if (value === '') return null;
//   return Number(value);
// }

function MembersItem({num, source, has_group}) {

  const ctx = useCtx()

  function deleteItem() {
    deleteParticipant(ctx, source.id)
  }

  const [competition_format] = useAtom(getModelAtom('tournament.competition_format'))

  return (
    <div className="members-list-item">
      <Field
        required={false}
        type="select"
        name="seed"
        id="seed"
        ctx={ctx}
        atom={participantsAtom}
        actionAtom={setParticipantsAction}
        build_atom={seedAtom}
        onAtomChange={(handler, value, ctx, _atom) => {
          const participants = ctx.get(_atom);
          const participant = participants.find((item) => source.id === item.id)
          if (participant) {
            handler.setValue(participant.seed)
          }
        }}
        onHandlerChange={(handler, ctx, _atom) => {
          const value = toNumberOrNull(handler.getValue())
          const participants = ctx.get(_atom)
          return participants.map(p => {
            if (p.id === source.id) {
              return {...p, seed: value}
            }
            // если у другого участника уже такой же seed → сбрасываем
            if (Number.isFinite(p.seed) && p.seed === value) {
              return {...p, seed: null}
            }
            return p
          })
        }}
      />
      {has_group && (
        <Field
          required={false}
          type="select"
          name="group"
          id="group"
          ctx={ctx}
          atom={participantsAtom}
          build_atom={groupAtom}
          onAtomChange={(handler, value, ctx, _atom) => {
            const participants = ctx.get(_atom);
            const participant = participants.find((item) => source.id === item.id)
            if (participant) {
              handler.setValue(participant.group)
            }
          }}
          onHandlerChange={(handler, ctx, _atom) => {
            const value = toNumberOrNull(handler.getValue())
            const participants = ctx.get(_atom)
            return participants.map(p => {
              if (p.id === source.id) {
                return {...p, group: value}
              }
              return p
            })
          }}
        />
      )}
      {competition_format === 'singal' && (
        <div className="members-list-item__player">
          <div className="members-list-item__title">
            <SearchItem
              key='player'
              ctx={ctx}
              atom={participantsAtom}
              source={source.player}
              prop='player'
              source_id={source.id}
              // num={num}
            />
          </div>
        </div>
      ) || competition_format === 'double' && (
        <div className="members-list-item__player">
          <div className="members-list-item__title">
            <SearchItem
              key='player_1'
              ctx={ctx}
              atom={participantsAtom}
              source={source.player_1}
              prop='player_1'
              source_id={source.id}
              // num={num}
            />
          </div>
          <div className="members-list-item__title">
            <SearchItem
              key='player_2'
              ctx={ctx}
              atom={participantsAtom}
              source={source.player_2}
              prop='player_2'
              source_id={source.id}
              // num={num}
            />
          </div>
        </div>
      ) || competition_format == 'triple' && (
        <div className="members-list-item__player">
          <div className="members-list-item__title">
            <SearchItem
              key='player_1'
              ctx={ctx}
              atom={participantsAtom}
              source={source.player_1}
              prop='player_1'
              source_id={source.id}
              // num={num}
            />
          </div>
          <div className="members-list-item__title">
            <SearchItem
              key='player_2'
              ctx={ctx}
              atom={participantsAtom}
              source={source.player_2}
              prop='player_2'
              source_id={source.id}
              // num={num}
            />
          </div>
          <div className="members-list-item__title">
            <SearchItem
              key='player_3'
              ctx={ctx}
              atom={participantsAtom}
              source={source.player_3}
              prop='player_3'
              source_id={source.id}
              // num={num}
            />
          </div>
        </div>
      )}
      <div className="members-list-item__actions">
        <div className="members-list-item__action -delete" onClick={deleteItem}>
          <SvgSprite id="trash"/>
        </div>
      </div>
    </div>
  )
}

export default MembersItem